import "../../../shared/styles/list.css";
import "../../admin/reportDocumentList/styles.css";

import { Checkbox, Col, Input, Modal, notification, Row } from "antd";
import { useEffect, useState } from "react";

import { LoadingOutlined } from "@ant-design/icons";

import { getAdminInformation } from "../../../services/adminApi";
import {
  deactivateAdminServiceTypes,
  getDeactivatedAdminServiceTypeByServiceTypeId,
} from "../../../services/adminServiceTypeApi";
import AdminDTO from "../../../shared/dtos/adminDTO";
import AdminServiceTypeDTO from "../../../shared/dtos/adminServiceTypeDTO";

const DeactivateServiceType = ({
  serviceTypeId,
  setIsModalOpen,
  isModalOpen,
}: any) => {
  const [admins, setAdmins] = useState<AdminDTO[]>([]);
  const [checkedAdmins, setCheckedAdmins] = useState<number[]>([]);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [checkAll, setCheckAll] = useState(false);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [emailSearch, setEmailSearch] = useState<AdminDTO[]>([]);

  const fetchData = async () => {
    setLoading(true);

    const results: Array<AdminServiceTypeDTO> =
      await getDeactivatedAdminServiceTypeByServiceTypeId(serviceTypeId);
    const adminServiceTypeIdsFromDB = new Array<number>();
    const adminResults: Array<AdminDTO> = await getAdminInformation();
    setAdmins(adminResults);

    if (results.length) {
      results.forEach((adminServiceType: AdminServiceTypeDTO) => {
        if (adminServiceType.id) {
          adminServiceTypeIdsFromDB.push(adminServiceType.adminId);
        }
      });
      setCheckedAdmins(adminServiceTypeIdsFromDB);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (isModalOpen) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen]);

  const handleOk = async () => {
    setConfirmLoading(true);
    await deactivateAdminServiceTypes(serviceTypeId, checkedAdmins).then(() =>
      notification.success({
        message: "El tipo de servicio",
        description:
          "se desactivo para los administradores seleccionados exitosamente",
        placement: "bottom",
        key: "global",
      }),
    );
    setConfirmLoading(false);
    closeModalBehaviour();
  };

  const handleCancel = () => {
    closeModalBehaviour();
  };

  const closeModalBehaviour = () => {
    setIsModalOpen(false);
    setCheckedAdmins([]);
    setCheckAll(false);
  };

  const handleCheckAll = (e: any) => {
    setCheckAll(e.target.checked);
    setCheckedAdmins(
      admins.map((admin: AdminDTO) => {
        return admin.id;
      }),
    );
  };

  const onChange = (event: any) => {
    const { value, checked } = event.target;
    if (!checked) {
      let adminsClone = [...checkedAdmins];
      adminsClone = adminsClone.filter((x) => x !== value);
      setCheckedAdmins(adminsClone);
      setCheckAll(false);
      return;
    }
    setCheckedAdmins([...checkedAdmins, value]);
  };

  const filterCheckbox = (e: any) => {
    const { value } = e.target;
    setSearch(value);
    const result = admins.filter((admin: AdminDTO) => {
      return admin.name!.toLowerCase().startsWith(value.toLowerCase());
    });
    setEmailSearch(result);
  };

  return (
    <>
      <Modal
        title="Selecciona las compañias para desactivar el tipo de servicio"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        confirmLoading={confirmLoading}
        okText={confirmLoading ? "Cargando" : "Ok"}
      >
        <Row gutter={[32, 16]}>
          <Col span={24}>
            <Input placeholder="Ingresar nombre" onChange={filterCheckbox} />
          </Col>
          <Col span={24}>
            <Checkbox checked={checkAll} onChange={handleCheckAll}>
              Seleccionar todos
            </Checkbox>
          </Col>
          <Col
            span={24}
            style={{
              maxHeight: "30vh",
              overflowX: "hidden",
              overflowY: "scroll",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {loading && (
              <Col span={24} className="loading-container error-container">
                <LoadingOutlined style={{ fontSize: "50px" }} />
              </Col>
            )}
            {!loading && !search.length
              ? admins.map((x) => (
                  <Checkbox
                    value={x.id}
                    onChange={onChange}
                    checked={checkedAdmins?.includes(x.id!)}
                  >
                    {x.name}
                  </Checkbox>
                ))
              : emailSearch.map((x) => (
                  <Checkbox
                    value={x.id}
                    onChange={onChange}
                    checked={checkedAdmins?.includes(x.id!)}
                  >
                    {x.name}
                  </Checkbox>
                ))}
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default DeactivateServiceType;
